var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.context.repeatable
    ? _c("a", {
        class: _vm.context.classes.groupRepeatableRemove,
        attrs: {
          "data-disabled": _vm.context.model.length <= _vm.context.minimum,
          role: "button"
        },
        domProps: { textContent: _vm._s(_vm.context.removeLabel) },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.removeItem.apply(null, arguments)
          },
          keypress: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.removeItem.apply(null, arguments)
          }
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }